import update from 'immutability-helper'
import {
  LOGIN_ACTIVE,
  LOGIN_FAILED,
  LOGGED_OUT,
  LOGIN_AUTHENTICATED,
  LOGIN_SUCCESS,
  SET_STORE_SUCCESS,
  LOGIN_RESET_STATUS,
  GET_ACTIVE_USER_SUCCESS,
  LOGIN_WITH_TEMP_PASSWORD,
  LOGIN_WITH_TEMP_PASSWORD_SUCCESS,
  REFRESHED_LOGIN_TOKEN_SUCCESS,
  HAS_INVOICE_NUMBER,
  MOCKING_USER,
} from '../actions/action-types'

import { NO_STORE, NO_REPRESENTATIVE } from '../../models/stores'

const initialState = {
  token: '',
  refreshToken: '',
  decodedRefreshToken: {
    jti: null,
    exp: null,
  },
  name: '',
  isLoggingIn: false,
  selectStore: false,
  isLoggedIn: false,
  role: '',
  store: {
    storeUID: '',
    storeName: '',
    storeId: '',
    origStore: '',
  },
  userId: '',
  username: '',
  language: '',
  representative: {
    representativeUID: '',
    representativeName: '',
    origRepresentative: '',
  },
  authorities: [],
  temporaryPassword: false,
  incompleteUser: false,
  me: null,
  originalUser: null,
  hasInvoiceNumber: false,
}

function _isUserInfoIncomplete(response) {
  return !!Object.values(response).filter(v => /^\$_N\/A/g.exec(v)).length
}

function _removeDefaultValues(response) {
  const result = {}
  Object.keys(response).forEach(key => {
    if (typeof response[key] === 'string') {
      result[key] = response[key].replace(/^\$_N\/A/g, '')
    } else {
      result[key] = response[key]
    }
  })
  return result
}

// eslint-disable-next-line default-param-last
const auth = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_ACTIVE:
      return update(state, {
        isLoggingIn: { $set: true },
      })
    case LOGIN_FAILED:
      return update(initialState, {
        isLoggingIn: { $set: false },
      })
    case LOGIN_AUTHENTICATED: {
      let rep = NO_REPRESENTATIVE
      let store = NO_STORE

      if (action.response.decodedToken.representative) {
        rep = action.response.decodedToken.representative
      }

      if (action.response.decodedToken.store) {
        store = action.response.decodedToken.store // eslint-disable-line
      }

      return update(state, {
        isLoggingIn: { $set: true },
        selectStore: { $set: store === NO_STORE },
        isLoggedIn: { $set: false },
        token: { $set: action.response.token },
        refreshToken: { $set: action.response.refreshToken },
        decodedRefreshToken: {
          exp: { $set: action.response.decodedRefreshToken.exp },
          jti: { $set: action.response.decodedRefreshToken.jti },
        },
        name: { $set: action.response.name },
        role: { $set: action.response.decodedToken.role },
        store: {
          storeUID: { $set: store },
          origStore: { $set: store },
          storeName: { $set: '' },
        },
        userId: { $set: action.response.decodedToken.sub },
        language: {
          $set:
            action.response.decodedToken.language &&
            action.response.decodedToken.language.length > 1
              ? action.response.decodedToken.language
              : 'sv',
        },
        representative: {
          representativeUID: { $set: rep },
          representativeName: { $set: action.representativeName },
          origRepresentative: { $set: rep },
        },
        authorities: { $set: action.response.decodedToken.authorities },
        temporaryPassword: { $set: false },
      })
    }
    case LOGIN_SUCCESS:
      return update(state, {
        isLoggingIn: { $set: false },
        isLoggedIn: { $set: true },
        representative: {
          representativeName: { $set: action.representativeName },
        },
        store: {
          storeName: { $set: action.storeName },
          storeId: { $set: action.storeId },
        },
        username: { $set: action.username },
      })
    case REFRESHED_LOGIN_TOKEN_SUCCESS:
      return update(state, {
        token: { $set: action.response.token },
        refreshToken: { $set: action.response.refreshToken },
        decodedRefreshToken: {
          exp: { $set: action.response.decodedRefreshToken.exp },
          jti: { $set: action.response.decodedRefreshToken.jti },
        },
      })
    case SET_STORE_SUCCESS:
      return update(state, {
        token: { $set: action.response.token },
        refreshToken: { $set: action.response.refreshToken },
        decodedRefreshToken: {
          exp: { $set: action.response.decodedRefreshToken.exp },
          jti: { $set: action.response.decodedRefreshToken.jti },
        },
        name: { $set: action.response.name },
        representative: {
          representativeUID: {
            $set: action.response.decodedToken.representative,
          },
          representativeName: { $set: action.representativeName },
        },
        authorities: { $set: action.response.decodedToken.authorities },
        store: {
          storeUID: { $set: action.response.decodedToken.store },
          storeId: { $set: action.storeInfo.accountSystemId },
          storeName: { $set: action.storeInfo.storeName },
        },
        selectStore: { $set: false },
      })
    case HAS_INVOICE_NUMBER:
      return update(state, {
        hasInvoiceNumber: { $set: action.success },
      })
    case LOGGED_OUT:
      return initialState
    case LOGIN_RESET_STATUS:
      return update(state, {
        isLoggingIn: { $set: false },
      })
    case GET_ACTIVE_USER_SUCCESS:
      return update(state, {
        name: {
          $set: `${action.response.firstName} ${action.response.lastName}`,
        },
        userName: {
          $set: action.response.username,
        },
        me: { $set: _removeDefaultValues(action.response) },
        incompleteUser: {
          $set: _isUserInfoIncomplete(action.response),
        },
      })
    case LOGIN_WITH_TEMP_PASSWORD:
      return update(state, {
        temporaryPassword: { $set: true },
      })
    case LOGIN_WITH_TEMP_PASSWORD_SUCCESS:
      return update(state, {
        temporaryPassword: { $set: false },
      })
    case MOCKING_USER:
      return update(state, { originalUser: { $set: action.data } })
    default:
      return state
  }
}

export default auth
